import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'
import {
  faUser,
  faEllipsis,
  faPlus,
  faTrash,
  faSearch,
  faBackspace,
  faClose,
  faClipboard,
  faHistory,
  faBars,
  faShare,
  faInfoCircle,
  faMoon,
  faTrophy,
  faCheck,
  faLifeRing,
  faList,
  faPenToSquare,
  faUpload,
  faArrowUpRightFromSquare,
  faChevronLeft,
  faChevronRight,
  faPause,
  faKeyboard, faCircleXmark, faTriangleExclamation, faCircleCheck, faXmark, faArrowsRotate, faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {faTwitter, faBluesky, faPatreon} from '@fortawesome/free-brands-svg-icons';

const CH_ICONS = {
  user: faUser,
  ellipsis: faEllipsis,
  plus: faPlus,
  trash: faTrash,
  search: faSearch,
  backspace: faBackspace,
  close: faClose,
  twitter: faTwitter,
  clipboard: faClipboard,
  history: faHistory,
  bars: faBars,
  share: faShare,
  infoCircle: faInfoCircle,
  moon: faMoon,
  lifeRing: faLifeRing,
  trophy: faTrophy,
  check: faCheck,
  list: faList,
  penToSquare: faPenToSquare,
  upload: faUpload,
  arrowUpRightFromSquare: faArrowUpRightFromSquare,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  pause: faPause,
  keyboard: faKeyboard,
  bluesky: faBluesky,
  patreon: faPatreon,
  circleXmark: faCircleXmark,
  triangleExclamation: faTriangleExclamation,
  circleCheck: faCircleCheck,
  xmark: faXmark,
  arrowsRotate: faArrowsRotate,
  circleExclamation: faCircleExclamation,
}

export type CHIconsType = keyof typeof CH_ICONS

type Props = {
  icon: CHIconsType
} & Omit<FontAwesomeIconProps, 'icon'>

const Icon: React.FC<Props> = (props: Props) => {
  return <FontAwesomeIcon {...props} icon={CH_ICONS[props.icon] as IconProp} />
}

export default Icon
